// extracted by mini-css-extract-plugin
export var caption = "ExpertTalks-module--caption--aa3c0";
export var card = "ExpertTalks-module--card--7ca08";
export var container = "ExpertTalks-module--container--5311d";
export var dark = "ExpertTalks-module--dark--2ecd2";
export var duration = "ExpertTalks-module--duration--660c4";
export var fadeInAnimation = "ExpertTalks-module--fadeInAnimation--c892e";
export var img = "ExpertTalks-module--img--c95f4";
export var imgWrapper = "ExpertTalks-module--imgWrapper--f6926";
export var tag = "ExpertTalks-module--tag--daf96";
export var title = "ExpertTalks-module--title--9617b";